// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaLinkedin,
  FaTwitter,
  FaTelegram,
  FaWhatsapp,
} from "react-icons/fa";
import { track } from "@vercel/analytics"; // ✅ Added

const Footer = () => {
  // ✅ Wrapper function for tracking link clicks
  const handleTrack = (label) => {
    track("footer_link_click", { page: window.location.pathname, link: label });
  };

  return (
    <footer className="padho-footer">
      <div className="footer-top">
        <div className="footer-brand">
          <h2>
            <strong>PrrepX Pathshala</strong>
          </h2>
          <p>
            We believe every student deserves an access to best-quality contents.
            PrrepX Pathshala provides the most structured and best quality content
            to every students of India for IIT-JEE/NEET and class 6-12th
            preparations. Led by IIT/NIT alumani.
          </p>

          <p className="social-title">Our Social Media Pages:</p>
          <div className="social-icons">
            <a
              href="https://facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="tooltip"
              onClick={() => handleTrack("Facebook")}
            >
              <FaFacebook color="#1877F2" />
              <span className="tooltip-text">Facebook</span>
            </a>

            <a
              href="https://youtube.com/@PrrepXPATHSHALA"
              target="_blank"
              rel="noopener noreferrer"
              className="tooltip"
              onClick={() => handleTrack("YouTube")}
            >
              <FaYoutube color="#FF0000" />
              <span className="tooltip-text">YouTube</span>
            </a>

            <a
              href="https://linkedin/in/hlvcse"
              target="_blank"
              rel="noopener noreferrer"
              className="tooltip"
              onClick={() => handleTrack("LinkedIn")}
            >
              <FaLinkedin color="#0A66C2" />
              <span className="tooltip-text">LinkedIn</span>
            </a>

            <a
              href="https://t.me/+817083110880"
              target="_blank"
              rel="noopener noreferrer"
              className="tooltip"
              onClick={() => handleTrack("Telegram")}
            >
              <FaTelegram color="#0088cc" />
              <span className="tooltip-text">Telegram</span>
            </a>

            <a
              href="https://wa.me/918287648766"
              target="_blank"
              rel="noopener noreferrer"
              className="tooltip"
              onClick={() => handleTrack("WhatsApp")}
            >
              <FaWhatsapp color="#25D366" />
              <span className="tooltip-text">WhatsApp</span>
            </a>

            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="tooltip"
              onClick={() => handleTrack("Twitter")}
            >
              <FaTwitter color="#1DA1F2" />
              <span className="tooltip-text">Twitter(X)</span>
            </a>

            <a
              href="https://instagram.com/hlvcse"
              target="_blank"
              rel="noopener noreferrer"
              className="tooltip"
              onClick={() => handleTrack("Instagram")}
            >
              <FaInstagram color="#E4405F" />
              <span className="tooltip-text">Instagram</span>
            </a>
          </div>
        </div>

        <div className="footer-columns">
          <div>
            <h4>Company</h4>
            <ul>
              <li>
                <Link to="/login" onClick={() => handleTrack("Login")}>
                  Login
                </Link>
              </li>
              <li>
                <Link to="/signup" onClick={() => handleTrack("Sign Up")}>
                  Sign Up
                </Link>
              </li>
              <li>
                <Link to="/meetourteam" onClick={() => handleTrack("Meet Our Team")}>
                  Meet Our Team
                </Link>
              </li>
              <li>
                <Link to="/contact-us" onClick={() => handleTrack("Contact Us")}>
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" onClick={() => handleTrack("Cancellation & Refund Policy")}>
                  Cancellation & Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/shipping-policy" onClick={() => handleTrack("Shipping Policy")}>
                  Shipping Policy
                </Link>
              </li>
              
              <li>
                <Link to="/after12" onClick={() => handleTrack("Courses After 12th")}>
                  Courses After 12th
                </Link>
              </li>
              <li>
                <Link to="/careers" onClick={() => handleTrack("Careers Page")}>
                  Careers Page
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>Our Premium Test Series</h4>
            <ul>
              <li>
                <Link to="/test-series" onClick={() => handleTrack("Test Series Main Page")}>
                  Test Series Main Page
                </Link>
              </li>
              <li>
                <Link
                  to="/test-series/all-india-iitjee-test-series"
                  onClick={() => handleTrack("All India Test Series (JEE)")}
                >
                  All India Test Series(JEE Mains & Adv)
                </Link>
              </li>
              <li>
                <Link
                  to="/test-series/all-india-neet-test-series"
                  onClick={() => handleTrack("All India Test Series (NEET)")}
                >
                  All India Test Series(NEET)
                </Link>
              </li>
              <li>
                <Link
                  to="/test-series/pyq-jeemains-test-series"
                  onClick={() => handleTrack("PYQ JEE Mains")}
                >
                  Previous Year Test Series(JEE Mains)
                </Link>
              </li>
              <li>
                <Link
                  to="/test-series/pyq-jeeadv-test-series"
                  onClick={() => handleTrack("PYQ JEE Adv")}
                >
                  Previous Year Test Series(JEE Adv)
                </Link>
              </li>
              <li>
                <Link
                  to="/test-series/pyq-neet-test-series"
                  onClick={() => handleTrack("PYQ NEET")}
                >
                  Previous Year Test Series(NEET)
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>IIT-JEE/NEET Lectures</h4>
            <ul>
              <li>
                <Link
                  to="/tutorials/iitjee-mathematics"
                  onClick={() => handleTrack("IITJEE Mathematics")}
                >
                  IIT-JEE Mathematics Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/iitjee-physics"
                  onClick={() => handleTrack("IITJEE/NEET Physics")}
                >
                  IIT-JEE/NEET Physics Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/iitjee-chemistry"
                  onClick={() => handleTrack("IITJEE/NEET Chemistry")}
                >
                  IIT-JEE/NEET Chemistry Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/biology-placeholder"
                  onClick={() => handleTrack("NEET Biology")}
                >
                  NEET Biology Lectures
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>Class 11-12th Lectures</h4>
            <ul>
              <li>
                <Link
                  to="/tutorials/class12-mathematics"
                  onClick={() => handleTrack("Class12 Mathematics")}
                >
                  Class12 Mathematics Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class12-physics"
                  onClick={() => handleTrack("Class12 Physics")}
                >
                  Class12 Physics Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class12-chemistry"
                  onClick={() => handleTrack("Class12 Chemistry")}
                >
                  Class12 Chemistry Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/biology-placeholder"
                  onClick={() => handleTrack("Class12 Biology")}
                >
                  Class12 Biology Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class11-mathematics"
                  onClick={() => handleTrack("Class11 Mathematics")}
                >
                  Class11 Mathematics Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class11-physics"
                  onClick={() => handleTrack("Class11 Physics")}
                >
                  Class11 Physics Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class11-chemistry"
                  onClick={() => handleTrack("Class11 Chemistry")}
                >
                  Class11 Chemistry Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/biology-placeholder"
                  onClick={() => handleTrack("Class11 Biology")}
                >
                  Class11 Biology Lectures
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>Class 6-10th Lectures</h4>
            <ul>
              <li>
                <Link
                  to="/tutorials/class10-mathematics"
                  onClick={() => handleTrack("Class10 Mathematics")}
                >
                  Class10 Mathematics Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class10-science"
                  onClick={() => handleTrack("Class10 Science")}
                >
                  Class10 Science Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class9-mathematics"
                  onClick={() => handleTrack("Class9 Mathematics")}
                >
                  Class9 Mathematics Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class9-science"
                  onClick={() => handleTrack("Class9 Science")}
                >
                  Class9 Science Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class8-mathematics"
                  onClick={() => handleTrack("Class8 Mathematics")}
                >
                  Class8 Mathematics Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class8-science"
                  onClick={() => handleTrack("Class8 Science")}
                >
                  Class8 Science Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class7-mathematics"
                  onClick={() => handleTrack("Class7 Mathematics")}
                >
                  Class7 Mathematics Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class7-science"
                  onClick={() => handleTrack("Class7 Science")}
                >
                  Class7 Science Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class6-mathematics"
                  onClick={() => handleTrack("Class6 Mathematics")}
                >
                  Class6 Mathematics Lectures
                </Link>
              </li>
              <li>
                <Link
                  to="/tutorials/class6-science"
                  onClick={() => handleTrack("Class6 Science")}
                >
                  Class6 Science Lectures
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>Previous Years Questions(PYQs)</h4>
            <ul>
              <li>
                <Link
                  to="/pyqs/yearwise"
                  onClick={() => handleTrack("PYQ Yearwise")}
                >
                  Previous Years Question Papers(PDF)
                </Link>
              </li>
              <li>
                <Link
                  to="/pyqs/chapterwise"
                  onClick={() => handleTrack("PYQ Chapterwise")}
                >
                  IIT-JEE PYQ - Chapterwise
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>Know Your Founder</h4>
            <ul>
              <li>
                <strong>Hanumat Lal Vishwakarma</strong>
              </li>
              <li>Software Engineer at Rakuten Group Inc. Tokyo, Japan</li>
              <li>M.Tech(CSE) – IIT Ropar, B.Tech(CSE) - NIT Manipur</li>
              <li>
                <a
                  href="mailto:PrrepXpathshala@gmail.com"
                  onClick={() => handleTrack("Email Founder")}
                >
                  Email Founder
                </a>
              </li>
              <li>
                <a
                  href="https://linkedin.com/in/hlvcse"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => handleTrack("Founder LinkedIn")}
                >
                  Connect on LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} PrrepX Pathshala. All rights reserved.
        </p>
        <p>
          <Link to="/privacy-policy" onClick={() => handleTrack("Privacy Policy")}>
            Privacy Policy
          </Link>{" "}
          |{" "}
          <Link to="/terms-conditions" onClick={() => handleTrack("Terms & Conditions")}>
            Terms & Conditions
          </Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
